import { __ } from '@wordpress/i18n';
import { PanelBody, RangeControl, FontSizePicker,
    __experimentalToggleGroupControl as ToggleGroupControl,
    __experimentalToggleGroupControlOption as ToggleGroupControlOption} from '@wordpress/components';
import Navigation from './navigation-effect.js';
import { VayuBlocksDevice ,VayuBlocksDeviceControl } from '@vayu-blocks/device-control';
import { VayuBlocksToggleControl,VayuBlocksBorder,VayuBlocksDimensions,VayuBlocksBackground,
    VayuBlocksDropShadow,VayuBlockBorderFrame, VayuBlocksAlignment, HeightControl } from '@vayu-blocks';
import { IconPicker } from './icon-picker.js';

const StyleSettings = ( { attributes, setAttributes, openPanels, onTogglePanel } ) => {

    const getView = VayuBlocksDevice();

    const getResponsiveValue = (key) => {
        switch (getView) {
            case 'Desktop':
                return attributes[key];
            case 'Tablet':
                return attributes[`${key}Tablet`];
            case 'Mobile':
                return attributes[`${key}Mobile`];
            default:
                return attributes[key];
        }
    };

    const setResponsiveValue = (key, value) => {
        switch (getView) {
            case 'Desktop':
                setAttributes({ [key]: value });
                break;
            case 'Tablet':
                setAttributes({ [`${key}Tablet`]: value });
                break;
            case 'Mobile':
                setAttributes({ [`${key}Mobile`]: value });
                break;
        }
    };

    return (

        <>

        <PanelBody title={ __( 'Arrow', 'vayu_blocks' ) } opened={openPanels['slide-arrow']} onToggle={() => onTogglePanel('slide-arrow')}>

            <VayuBlocksToggleControl
                label={ __( 'Navigation', 'vayu_blocks' ) }
                checked={ attributes.navigation }
                onChange={ ( value ) =>setAttributes( { navigation: value } )}
            />

            {attributes.navigation && (
                <>
                    <ToggleGroupControl
                        value={ attributes.navigationtype}
                        __next40pxDefaultSize={true}
                        __nextHasNoMarginBottom={true}
                        isBlock
                        onChange={(value)=>setAttributes({navigationtype:value}) } 
                    >
                        <ToggleGroupControlOption
                            label='Default'
                            value="default"
                        />
                        <ToggleGroupControlOption
                            label="On Hover"
                            value="hover"
                        />
                    </ToggleGroupControl>

                    <IconPicker
                        Icon={attributes.selectedFoldIcon}
                        onIconSelect={(icon) => {
                            setAttributes({ selectedFoldIcon: icon }); // Ensure this updates fold icon only
                        }}
                    />

                    <br/>
                 
                    <FontSizePicker
                        label={<VayuBlocksDeviceControl label={__('Font Size', 'vayu-blocks')} classname='bold' />}
                        fontSizes={[
                            {
                                name: 'Small',
                                size: 15,
                                slug: 'small'
                            },
                            {
                                name: 'Normal',
                                size: 25,
                                slug: 'normal'
                            },
                            {
                                name: 'Big',
                                size: 35,
                                slug: 'big'
                            }
                        ]}
                        onChange={(value) => setResponsiveValue('navigationsize',value)}  // Pass the function reference correctly
                        value={getResponsiveValue('navigationsize')}  // Get the current font size
                    />

                    <br/>
                    <RangeControl
                        label={<VayuBlocksDeviceControl label={__('Top/Bottom', 'vayu-blocks')} classname='bold' />}
                        onChange={(value) => setResponsiveValue('navigationtop',value)}  // Pass the function reference correctly
                        value={getResponsiveValue('navigationtop')}
                        __next40pxDefaultSize={true}
                        __nextHasNoMarginBottom={true}
                    />

                    <RangeControl
                        label={<VayuBlocksDeviceControl label={__('Left/Right', 'vayu-blocks')} classname='bold' />}
                        onChange={(value) => setResponsiveValue('rightarrow',value)}  // Pass the function reference correctly
                        value={getResponsiveValue('rightarrow')}
                        min={5}
                        max={100}
                        __next40pxDefaultSize={true}
                        __nextHasNoMarginBottom={true}
                    />

                    <div className='vayu-blcoks-fixing-dimesnions'>
                        <VayuBlocksDimensions  
                            onChange={(key,value)=>setAttributes({[key]:value})}
                            dimensions = {{
                                    padding:{key:'arrowpadding',value:attributes.arrowpadding},
                            }}
                        />
                    </div>

                    <VayuBlocksBackground
                    onChange={(key,value)=>setAttributes({[key]:value})}
                        //setAttributes={setAttributes}
                        colorPanel = {[
                            {
                                active: ['gradient'],
                                label: 'Background',
                                key:'navigationbackground',
                                value:attributes.navigationbackground
    
                            },
                            {
                                active: ['color'],
                                label: 'Icon',
                                key:'navigationcolor',
                                value:attributes.navigationcolor
                            },
                        ]}
                    />

                    <VayuBlocksBorder 
                        onChange={(key,value)=>setAttributes({[key]:value})}
                        border={{key:'arrowborder',value:attributes.arrowborder}}
                        borderRadius={{key:'arrowborderradius',value:attributes.arrowborderradius}} 
                    /> 

            </>
            )}

        </PanelBody>

        <PanelBody title={ __( 'Pagination', 'vayu_blocks' ) } opened={openPanels['slide-pagination']} onToggle={() => onTogglePanel('slide-pagination')}>
            <VayuBlocksToggleControl
                label={ __( 'Pagination', 'vayu_blocks' ) }
                checked={ attributes.pagination }
                onChange={ ( value ) =>setAttributes( { pagination: value } )}
            />

            {attributes.pagination && (
                <>
                    <Navigation
                        navigationValue={attributes.dotstype} 
                        onnavigationChange={ ( value ) =>
                            setAttributes({dotstype:value})
                        }
                    />

                    {attributes.dotstype != 'progressbar' && (
                        <>
                        
                            <VayuBlocksAlignment
                                onChange={(key,value)=>setAttributes({[key]:value})}
                                alignment = {{key:'dotsalignment',value:attributes.dotsalignment}}
                            />

                            <RangeControl
                                label={<VayuBlocksDeviceControl label={__('Size', 'vayu-blocks')} classname='bold' />}
                                onChange={(value) => setResponsiveValue('bulletsize',value)}
                                value={getResponsiveValue('bulletsize')}
                                __nextHasNoMarginBottom={true}
                                __next40pxDefaultSize={true}
                            />

                            {attributes.dotstype != 'numbers' && (

                                <VayuBlocksBackground
                                    onChange={(key,value)=>setAttributes({[key]:value})}
                                    colorPanel = {[
                                        {
                                            active: ['gradient'],
                                            label: 'Active',
                                            key:'paginationbackground',
                                            value:attributes.paginationbackground

                                        },
                                        {
                                            active: ['gradient'],
                                            label: 'Inactive',
                                            key:'paginationinactivebackground',
                                            value:attributes.paginationinactivebackground
                                        },
                                    ]}
                                />
                            )}
                        </>
                    )}  
                    
                    {attributes.dotstype === 'numbers' && (

                        <VayuBlocksBackground
                        onChange={(key,value)=>setAttributes({[key]:value})}
                            colorPanel = {[
                                {
                                    active: ['color'],
                                    label: 'Numbers',
                                    key:'numberscolor',
                                    value:attributes.numberscolor
                                },
                                
                            ]}
                        />
                    )}

                    {attributes.dotstype === 'progressbar' && (
                        <>
                            <VayuBlocksToggleControl
                                label={ __( 'On Hover', 'vayu_blocks' ) }
                                checked={ attributes.progresshover }
                                onChange={ ( value ) =>
                                    setAttributes( { progresshover: value } )
                                }
                            />

                            <RangeControl
                                label={<VayuBlocksDeviceControl label={__('Size', 'vayu-blocks')} classname='bold' />}
                                onChange={(value) => setResponsiveValue('progresssize',value)}  // Pass the function reference correctly
                                value={getResponsiveValue('progresssize')}
                                max={20}
                                __nextHasNoMarginBottom={true}
                                __next40pxDefaultSize={true}
                            />

                            <VayuBlocksBackground
                                onChange={(key,value)=>setAttributes({[key]:value})}
                                colorPanel = {[
                                    {
                                        active: ['color'],
                                        label: 'Progress',
                                        key:'progresscolor',
                                        value:attributes.progresscolor
                                    },
                                    
                                ]}
                            />
                        </>
                    )}

                    <VayuBlocksBackground
                        onChange={(key,value)=>setAttributes({[key]:value})}
                        headingLabel="Background"
                        colorPanel = {[
                            {
                                active: ['gradient'],
                                label: 'Background',
                                key:'dotsbackground',
                                value:attributes.dotsbackground
                            },
                        ]}
                    />

                    <HeightControl
                        label={__('Bottom', 'vayu-blocks')}
                        value={ attributes.dotsheight }
                        onChange={ (value) => setAttributes({ dotsheight: value }) }
                        responsive={true}
                        customUnits={['px']}
                    />
                  
                </>
            )}

        </PanelBody>

        <PanelBody title={ __( 'Scroll Bar', 'vayu_blocks' ) } opened={openPanels['slide-bar']} onToggle={() => onTogglePanel('slide-bar')}>
                <VayuBlocksToggleControl
                    label={ __( 'Scroll Bar', 'vayu_blocks' ) }
                    checked={ attributes.scrollbar }
                    onChange={ ( value ) =>
                        setAttributes( { scrollbar: value } )
                    }
                />
            {attributes.scrollbar && (
                <>

                    <ToggleGroupControl
                        value={ attributes.scrolltype}
                        __next40pxDefaultSize={true}
                        __nextHasNoMarginBottom={true}
                        isBlock
                        onChange={(value)=>setAttributes({scrolltype:value}) } 
                    >
                        <ToggleGroupControlOption
                            label='Default'
                            value="default"
                        />
                        <ToggleGroupControlOption
                            label="On Hover"
                            value="hover"
                        />
                    </ToggleGroupControl>

                    <RangeControl
                        label={ __( 'Scroll Bar Height (px)', 'vayu_blocks' ) }
                        value={ attributes.scrollheight }
                        min={ 0 } // Minimum should be 1 since you can't show 0 slides
                        max={ 100 }
                        onChange={ ( value ) =>
                            setAttributes( { scrollheight: value } )
                        }
                        __nextHasNoMarginBottom={true}
                        __next40pxDefaultSize={true}
                    />

                    <HeightControl
                        label={__('Top', 'vayu-blocks')}
                        value={ attributes.scrolltop }
                        onChange={ (value) => setAttributes({ scrolltop: value }) }
                        responsive={true}
                    />

                     <VayuBlocksBackground
                        setAttributes={setAttributes}
                        onChange={(key,value)=>setAttributes({[key]:value})}
                        colorPanel = {[
                            {
                                active: ['gradient'],
                                label: 'Scroll Box',
                                key:'scrollBox',
                                value:attributes.scrollBox

                            },
                            {
                                active: ['gradient'],
                                label: 'Scroll',
                                key:'scroll',
                                value:attributes.scroll
                            },
                        ]}
                    />
                </>
            )}

        </PanelBody>

        <PanelBody title={__('Global Frame','vayu-blocks')} opened={openPanels['slide-frame']} onToggle={() => onTogglePanel('slide-frame')}>

                <VayuBlockBorderFrame
                    frameData={attributes.frameData}
                    onChange={(key,value)=>setAttributes({[key]:value})}
                    dataKey="frameData"
                />
                 
                 <br/>
                <VayuBlocksDropShadow 
                    onChange={(key,value)=>setAttributes({[key]:value})}
                    dropShadow={{key:'advanceglobaldropshadow',value:attributes.advanceglobaldropshadow}}
                />

        </PanelBody>

        </>
    );
};

export default StyleSettings;